<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row no-gutters>
      <v-col cols="12">
        <v-card
          v-if="Object.keys(termDates).length"
          class="pa-2"
          outlined
        >
          <v-row class="justify-space-between">
            <v-col
              v-for="(dates, term) in termDates"
              v-if="dates"
              :key="term"
              cols="6"
            >
              <div class="font-weight-medium">{{ term }}</div>
              <div class="text-caption text--secondary">{{ dates }}</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        class="fill-height"
        cols="12"

        ref="calendar"
        id="calendar"/>
    </v-row>
    <v-dialog
      v-model="eventDialog"
      width="300">
      <v-card>
        <v-card-text v-html="eventDialogBody"/>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="googleEventDialog"
      width="300">
      <v-card>
        <v-card-title class="font-weight-bold pb-0">{{ googleEventObj.summary }}</v-card-title>
        <v-card-text
          class="pt-0"
          v-if="typeof googleEventObj.start.date !== 'undefined' && googleEventObj.start.date !== ''">{{ googleEventObj.start.date | moment("dddd D MMMM") }}<span v-if="(new Date(googleEventObj.end.date) - new Date(googleEventObj.start.date)) > 86400000"> - {{ getMultiDayEndDate(googleEventObj.end.date) | moment("dddd D MMMM") }}</span></v-card-text>
        <v-card-text
          class="pt-0"
          v-if="typeof googleEventObj.start.dateTime !== 'undefined' && googleEventObj.start.dateTime !== ''">{{ googleEventObj.start.dateTime | moment("D MMMM YYYY h:mm a") }} - {{ googleEventObj.end.dateTime | moment("D MMMM YYYY h:mm a") }} </v-card-text>
        <v-divider/>
        <v-card-text v-if="typeof googleEventObj.description !== 'undefined' && googleEventObj.description !== ''"><span v-html="sanitizeHTML(googleEventObj.description)"/></v-card-text>
        <!--        <v-card-text v-if="cleanDescript !== ''">{{ cleanDescript }}</v-card-text>-->
        <v-card-text>Created by {{ googleEventObj.creator.email }}</v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import googleCalendarPlugin from '@fullcalendar/google-calendar'
import DOMPurify from 'dompurify'

export default {
  data: () => ({
    eventDialog: false,
    eventDialogBody: '',

    googleEventDialog: false,
    googleEventObj: {
      summary: '',
      description: '',
      creator: {
        email: ''
      },
      start: {
        date: ''
      }
    },

    googleCalendarApiKey: 'AIzaSyB4ZWrGRKp2NSZJrhVyW9HjeGBrW1dNhAo',
    googleCalendar: {},
    googleCalendarEnabled: false,
    googleCalendarId: '',
    eventsObject: {},
    url: '',
    termDates: {}
  }),

  computed: {
    // cleanDescript () {
    //   if (this.googleEventObj.description) {
    //     return this.cleanHtmlTags(this.googleEventObj.description)
    //   }
    // }
  },
  methods: {
    // cleanHtmlTags (text) {
    //   return text.replace(/<\/?[^>]+(>|$)/g, '')
    // },
    sanitizeHTML (html) {
      return DOMPurify.sanitize(html)
    },
    getQueryString: function (field, url) {
      let reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i')
      let string = reg.exec(url)
      return string[1]
    },

    getMultiDayEndDate: function (endDate) { // Must subtract one from the end date to show onclick popup properly
      let dt = new Date(endDate)
      dt.setDate(dt.getDate() - 1)
      return dt
    },

    initialiseCalendar: function () {
      const calendar = new Calendar(this.$refs.calendar, {
        plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, googleCalendarPlugin ],
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,listWeek'
        },
        height: 'parent',
        googleCalendarApiKey: this.googleCalendarApiKey,
        events: this.eventsObject,

        eventClick: info => {
          info.jsEvent.preventDefault() // don't let the browser navigate
          let eventId = info.event.id
          if (this.googleCalendarEnabled) {
            if (eventId) {
              this.$http({
                method: 'get',
                url: 'https://www.googleapis.com/calendar/v3/calendars/' + this.googleCalendarId + '/events/' + eventId + '?key=' + this.googleCalendarApiKey,
                transformRequest: [(data, headers) => {
                  delete headers.common['Authorization']
                  return data
                }]
              })
                .then(resp => {
                  this.googleEventObj = resp.data
                  this.googleEventDialog = true
                })
            }
          } else {
            if (info.event.url) {
              this.$http.get(info.event.url).then(resp => {
                this.eventDialogBody = resp.data
              })
              this.eventDialog = true
            }
          }
        }
      })
      calendar.render()
      calendar.changeView('dayGridMonth')
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      // Check if google calendar enabled and get the url
      vm.$http
        .get('googlecalendarV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.googleCalendar = resp.data
          vm.url = resp.data.url
          if (resp.data.enabled) {
            vm.googleCalendarEnabled = resp.data.enabled
            vm.googleCalendarId = decodeURIComponent(vm.getQueryString('src', resp.data.url))
            vm.eventsObject = {
              googleCalendarId: vm.googleCalendarId
            }
          } else {
            vm.eventsObject = {
              url: 'https://www.atschool.co.nz/main18/mod_calendar/plugin/getEvents_JSON.php?db=' + vm.$store.state.Dbasename + '&pid=' + vm.$store.state.pupilId
            }
          }
          vm.initialiseCalendar()

          vm.$http.get('getTermDates/' + vm.$store.state.Dbasename)
            .then(resp => {
              if (resp.data) {
                vm.termDates = resp.data
              }
            })

          vm.$store.commit('loading', false)
        })
    })
  }
}
</script>

<style>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/list/main.css';
@import '~@fullcalendar/timegrid/main.css';

.fc-toolbar .fc-state-active {
  z-index: 1;
}
.fc-toolbar .fc-state-hover {
  z-index: 1;
}
.fc-toolbar button:focus {
  z-index: 1;
}
/* .fc button {
  font-size: 0.8em;
} */
.fc-center > h2 {
  font-size: 1.2em;
}
.important {
  background-color: #fd9393;
  border-color: #e8e8e8;
  color: black;
  font-weight: bold;
}
.important:hover {
  color: black;
}
.holiday {
  background-color: #90c4e2;
  border-color: #e8e8e8;
  color: black;
  font-weight: bold;
}
.holiday:hover {
  color: black;
}
.fc-title {
  color: white;
}
.fc-time {
  color: white;
}
</style>
